import { MutationTree } from 'vuex';

// Store and store types
import Store from '@/store';
import { RootState, StepsMutation, FooterMutation } from '@/store/store.types';

// Step tupes
import { StepConfig } from '@/steps/types';

/**
 *  Holding all the mutations of the steps.
 */
export const Mutations: MutationTree<RootState> = {

    /**
     *
     *  Used to update the current step state.
     *
     *  (i) Also updates the footer's info state
     *  for the step accordingly
     *
     */
    [StepsMutation.CURRENT](state: RootState, step: StepConfig): void {

        state.steps.current = step;

        /**
         *  Update the footer's info accordingly, taking
         *  the info from the step's configuration.
         */
        Store.commit(FooterMutation.INFO, step.info ?? null);

    },

};
